module.exports = __webpack_public_path__ + "img/red-bow.a673c540.png";